var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        position: "fixed",
        bottom: "10px",
        left: "10px",
        "z-index": "1000"
      }
    },
    [
      _vm._l(_vm.requestsList, function(current) {
        return [
          current.loaded
            ? _c(
                "v-chip",
                {
                  key: current.id,
                  staticClass: "mr-1 mt-1 elevation-2",
                  attrs: {
                    color: current.active ? "opposite" : null,
                    close: "",
                    "close-icon": "close"
                  },
                  on: {
                    "click:close": function($event) {
                      return _vm.removeCurrent(current.id)
                    },
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.setCurrentActive(current.data)
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        small: "",
                        color: current.active ? current.color : null
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage(`requests.tab.${current.icon}`)
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(current.property))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mx-1" }, [
                    _vm._v("| " + _vm._s(current.id) + " |")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "font-weight-bold",
                      class: { [`${current.color}--text`]: current.active }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage(
                              `requests.tab.${current.message}`
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _vm._l(_vm.PEMcurrents, function(current) {
        return _c(
          "v-chip",
          {
            key: current.id,
            staticClass: "mr-1 mt-1 elevation-2",
            attrs: {
              close: "",
              "close-icon": "close",
              color: current.id === _vm.openedCurrent ? "opposite" : null
            },
            on: {
              "click:close": function($event) {
                return _vm.removePEMCurrent(current)
              },
              click: function($event) {
                $event.stopPropagation()
                return _vm.addPEMCurrent(current)
              }
            }
          },
          [
            _c(
              "v-icon",
              {
                staticClass: "mr-2",
                attrs: {
                  small: "",
                  color: current.id === _vm.openedCurrent ? "primary" : null
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.generateMessage("alerts.icon")) +
                    "\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(current.name))
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }